/**
 *
 * Asynchronously loads the component for AdvisorSignin
 *
 */

import { lazyLoad } from 'utils/loadable';

export const AdvisorSignin = lazyLoad(
  () => import('./index'),
  module => module.AdvisorSignin,
);
